import fetchAppInfo from "./utils/fetchAppInfo";
import fetchDeviceInfo from "./utils/fetchDeviceInfo";
import fetchEnvironmentInfo from "./utils/fetchEnvironment";
import fetchLocaleInfo from "./utils/fetchLocaleInfo";
import fetchNetworkInfo from "./utils/fetchNetworkInfo";
import fetchPermissionInfo from "./utils/fetchPermission";
import fetchSessionInfo from "./utils/fetchSessionInfo";
import { fetchPurchasesInfo } from "./utils/fetchPurchasesInfo";

import type { AppUserSession } from "@/schemas/auth/session";
import {
  DiagnosticCategory,
  type DiagnosticRun,
} from "@/schemas/app/diagnostic";

export const fetchDiagnostics = async (
  session: AppUserSession | null,
): Promise<DiagnosticRun> => {
  const deviceDiagnostics = await fetchDeviceInfo();
  const localeDiagnostics = await fetchLocaleInfo();
  const appDiagnostics = await fetchAppInfo();
  const purchasesDiagnostics = await fetchPurchasesInfo();
  const sessionDiagnostics = await fetchSessionInfo(session?.token ?? null);
  const permissionDiagnostics = await fetchPermissionInfo();
  const networkDiagnostics = await fetchNetworkInfo();
  const environmentDiagnostics = await fetchEnvironmentInfo();

  return {
    [DiagnosticCategory.DEVICE]: deviceDiagnostics,
    [DiagnosticCategory.ENVIRONMENT]: environmentDiagnostics,
    [DiagnosticCategory.APP]: appDiagnostics,
    [DiagnosticCategory.PURCHASES]: purchasesDiagnostics,
    [DiagnosticCategory.UPDATE]: [],
    [DiagnosticCategory.LAYOUT]: [],
    [DiagnosticCategory.SESSION]: sessionDiagnostics,
    [DiagnosticCategory.PERMISSION]: permissionDiagnostics,
    [DiagnosticCategory.NETWORK]: networkDiagnostics,
    [DiagnosticCategory.LOCALE]: localeDiagnostics,
  };
};
